<template>
	<div class="lv-table-cell" :style="styles" :class="[`lv-table-cell-align-${align}`]">
		<template v-if="isFixed">
			<slot></slot>
		</template>
	</div>
</template>

<script>
    import LvScopeSlot from "../render/lv-scope-slot";
    import {TableMixin} from "./index";
    import PlTooltipText from "../tooltip/pl-tooltip-text";

    export default {
        name: "lv-table-cell",
        components: {PlTooltipText, LvScopeSlot},
        mixins: [TableMixin],
        props: {
            width: {},                          //单元格宽度
            height: {},                         //单元格高度
            isFixed: {default: false},          //是否为对应fixed table的cell
            align: {},
        },
        computed: {
            styles() {
                const styles = {
                    height: this.$lv.$utils.unit(this.height),
                    width: this.$lv.$utils.unit(this.width),
                }
                return styles
            },
        },
    }
</script>

<style lang="scss">
	.lv-table-cell {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		padding-left: $base-table-cell-padding;
		width: 100%;
		overflow: visible;

		&.lv-table-cell-align-left {
			.lv-table-cell-normal {
				text-align: left;

				.pl-tooltip-text {
					text-align: left;
				}
			}
		}

		&.lv-table-cell-align-center {
			padding-left: 0;

			.lv-table-cell-normal {
				text-align: center;

				.pl-tooltip-text {
					text-align: center;
				}
			}
		}

		&.lv-table-cell-align-right {
			.lv-table-cell-normal {
				text-align: right;

				.pl-tooltip-text {
					text-align: right;
				}
			}
		}
	}
</style>
